import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import CookieBanner from "@/components/site/CookieBanner";

export default function Layout({ children }) {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [location.pathname]);

    return (
        <div className="min-h-screen flex flex-col bg-cream-50 text-ink-900">
            <Header />
            <main className="flex-1">{children}</main>
            <Footer />
            <CookieBanner />
        </div>
    );
}
